import { createSlice, isRejected } from "@reduxjs/toolkit";

import {
  getColorSettingsThunk,
  updateColorSettingsThunk,
  restoreColorSettingsThunk,
  resetColorSettingsThunk,
} from "./thunks";
import { IColorSettingsState } from "./types";

const initialState: IColorSettingsState = {
  colorSettings: null,
  isLoading: false,
  isRestoreSettings: false,
};

const colorSettingsSlice = createSlice({
  name: "colorSettings",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getColorSettingsThunk.pending, state => {
        state.isLoading = true;
        state.isRestoreSettings = false;
      })
      .addCase(getColorSettingsThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.colorSettings = payload;
      })
      .addCase(updateColorSettingsThunk.pending, state => {
        state.isLoading = true;
        state.isRestoreSettings = false;
      })
      .addCase(updateColorSettingsThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.colorSettings = payload;
      })
      .addCase(restoreColorSettingsThunk.pending, state => {
        state.isLoading = true;
        state.isRestoreSettings = true;
      })
      .addCase(restoreColorSettingsThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.colorSettings = { ...state.colorSettings, ...payload };
      })
      .addCase(resetColorSettingsThunk.pending, state => {
        state.isLoading = true;
        state.isRestoreSettings = true;
      })
      .addCase(resetColorSettingsThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.colorSettings = payload;
      })
      .addMatcher(
        isRejected(
          resetColorSettingsThunk,
          restoreColorSettingsThunk,
          updateColorSettingsThunk,
          getColorSettingsThunk
        ),
        state => {
          state.isLoading = false;
          state.isRestoreSettings = false;
        }
      );
  },
});

export default colorSettingsSlice.reducer;
